import { ServerProfileStatsBase } from "abweb/dto/generated/profile/ServerProfileStatsBase";
export class ServerProfileStats extends ServerProfileStatsBase {
  static createServerProfileStats(avgActive, avgValue, firstAccess, label, lastAccess, lastValue, maxActive, maxValue, minValue, numActive, stdDevValue, totalValue, valueHits) {
    const retVal = new ServerProfileStats();
    retVal.initServerProfileStats(avgActive, avgValue, firstAccess, label, lastAccess, lastValue, maxActive, maxValue, minValue, numActive, stdDevValue, totalValue, valueHits);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=ServerProfileStats.js.map
